/**
 * Helpers compartidos para detección y parseo de fechas en filtros de tabla
 * (`filterUtils` y `filtering`).
 */

/**
 * Indica si el valor es un string con prefijo de fecha YYYY-MM-DD (o ISO).
 */
export const isDateString = (value: unknown): boolean => {
  if (!value || typeof value !== 'string') return false;
  return /^\d{4}-\d{2}-\d{2}/.test(value);
};

/**
 * Parsea una cadena de fecha (YYYY-MM-DD o ISO) a `Date` en hora local (solo parte fecha).
 */
export const parseDate = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Rango [start, end] para operadores de fecha relativa (mes/año actual o anterior).
 */
export const getRelativeDateRange = (operator: string): { start: Date; end: Date } => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  switch (operator) {
    case 'thisMonth': {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return { start, end };
    }
    case 'lastMonth': {
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return { start, end };
    }
    case 'thisYear': {
      const start = new Date(now.getFullYear(), 0, 1);
      const end = new Date(now.getFullYear(), 11, 31);
      return { start, end };
    }
    case 'lastYear': {
      const start = new Date(now.getFullYear() - 1, 0, 1);
      const end = new Date(now.getFullYear() - 1, 11, 31);
      return { start, end };
    }
    default:
      return { start: today, end: today };
  }
};
